import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import Form from '../components/Form';

export default HyperdbForm(Form, {
  namespace: 'cancellationPolicy',
  mountedUrl: '/daily-rental/cancellation-policies',
  titleNew: 'Create cancellation policy',
  titleEdit: 'Edit cancellation policy',
  displayName: (o, props) => o.name,
  checkIsValid: (props) => !!props.objectData.name,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/cancellation-policy/containers/Form.jsx